var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "justify-content-start" },
        [
          _vm.type == "BULK"
            ? _c(
                "b-col",
                { staticClass: "w-100", attrs: { md: "2" } },
                [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mb-3 justify-content-start" },
        [
          !_vm.flagBPCE && !_vm.flagTOOLBOX
            ? _c(
                "b-col",
                {
                  staticClass: "mt-2 text-xl-start",
                  attrs: { cols: "12", lg: "8", xl: "6" },
                },
                [
                  _vm.type !== "BULK"
                    ? _c(
                        "b-button-group",
                        {
                          staticClass: "mt-3 mt-sm-0",
                          staticStyle: {
                            display: "grid",
                            "grid-auto-flow": "column",
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant:
                                  _vm.filters.tabName === 1
                                    ? "primary btn-selected"
                                    : "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeTabName(1)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("tracking.DDV")))]
                          ),
                          _vm._v(" "),
                          _vm.flagCACP
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant:
                                      _vm.filters.tabName === 2
                                        ? "primary btn-selected"
                                        : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeTabName(2)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("tracking.DDD")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.activateSpinner
        ? _c("spinner")
        : _vm.TracksList.length > 0
        ? _c(
            "div",
            { staticStyle: { overflow: "auto" } },
            [
              _c("b-table", {
                staticClass: "table table-striped",
                staticStyle: { "margin-bottom": "0" },
                attrs: {
                  hover: "",
                  fields: _vm.fields,
                  items: _vm.TracksList,
                  selectable: _vm.TracksList.length > 0,
                  "empty-text": _vm.$t("common.security.no_result"),
                  role: "table",
                  "aria-label": "Liste des transactions de suivi",
                  "sticky-header": "",
                  "thead-class": "text-center",
                  "tbody-class": "text-center",
                },
                on: { "row-clicked": _vm.handleRowClicked },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(CreationDateRq1)",
                      fn: function (data) {
                        return [
                          _c("span", [_vm._v(_vm._s(_vm.getDate(data.value)))]),
                        ]
                      },
                    },
                    {
                      key: "cell(Request2CreationDate)",
                      fn: function (data) {
                        return [
                          _c("span", [_vm._v(_vm._s(_vm.getDate(data.value)))]),
                        ]
                      },
                    },
                    {
                      key: "cell(Response2CreationDate)",
                      fn: function (data) {
                        return [
                          _c("span", [_vm._v(_vm._s(_vm.getDate(data.value)))]),
                        ]
                      },
                    },
                    {
                      key: "cell(CreationDateRp2)",
                      fn: function (data) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getDate(data.item.Response2CreationDate)
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(NameScore)",
                      fn: function (data) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getResultText(data.value))),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(BICFrom)",
                      fn: function (data) {
                        return [_c("span", [_vm._v(_vm._s(data.value))])]
                      },
                    },
                    {
                      key: "cell(TestCaseStatus)",
                      fn: function (data) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getTestCaseStatus(data.value))),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(BICOnUs)",
                      fn: function (data) {
                        return [
                          data.value
                            ? _c("span", [
                                data.value == 1
                                  ? _c("i", {
                                      staticClass:
                                        "fa-regular fa-circle-check cursor color-var-actionButtonColorBlue",
                                      attrs: {
                                        "aria-label": _vm.$t("common.success"),
                                        role: "img",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                data.value == 2
                                  ? _c("i", {
                                      staticClass:
                                        "fa-regular fa-circle-xmark cursor text-danger",
                                      attrs: {
                                        "aria-label": _vm.$t("common.error"),
                                        role: "img",
                                      },
                                    })
                                  : _vm._e(),
                              ])
                            : _c("span", [_vm._v(" - ")]),
                        ]
                      },
                    },
                    {
                      key: "cell(BICTo)",
                      fn: function (data) {
                        return [_c("span", [_vm._v(_vm._s(data.value))])]
                      },
                    },
                    {
                      key: "cell(Country)",
                      fn: function (data) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.getCountry(data.item.CountryCode))
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(IBAN)",
                      fn: function (data) {
                        return [_c("span", [_vm._v(_vm._s(data.value))])]
                      },
                    },
                    {
                      key: "cell(Status)",
                      fn: function (data) {
                        return [_c("span", [_vm._v(_vm._s(data.value))])]
                      },
                    },
                    {
                      key: "cell(Name)",
                      fn: function (data) {
                        return [
                          data.item.FullName !== ""
                            ? _c("span", [_vm._v(_vm._s(data.item.FullName))])
                            : _c("span", [_vm._v(" - ")]),
                        ]
                      },
                    },
                    _vm.tabName === 2 && !_vm.flagBPCE
                      ? {
                          key: "cell(Type)",
                          fn: function (data) {
                            return [
                              data.item.Type === "2"
                                ? _c("i", {
                                    staticClass: "fa-solid fa-building",
                                    attrs: {
                                      "aria-label": _vm.$t("common.company"),
                                      role: "img",
                                    },
                                  })
                                : data.item.Type === "1"
                                ? _c("i", {
                                    staticClass: "fa-solid fa-user",
                                    attrs: {
                                      "aria-label": _vm.$t("common.individual"),
                                      role: "img",
                                    },
                                  })
                                : _c("span", [_vm._v(" - ")]),
                            ]
                          },
                        }
                      : null,
                    {
                      key: "cell(TestedData)",
                      fn: function (data) {
                        return [
                          data.item.FullName !== ""
                            ? _c("span", [_vm._v(_vm._s(data.item.FullName))])
                            : data.item.Siren !== ""
                            ? _c("span", [_vm._v(_vm._s(data.item.Siren))])
                            : data.item.Siret !== ""
                            ? _c("span", [_vm._v(_vm._s(data.item.Siret))])
                            : data.item.TVAIntracomm !== ""
                            ? _c("span", [
                                _vm._v(_vm._s(data.item.TVAIntracomm)),
                              ])
                            : data.item.LEI !== ""
                            ? _c("span", [_vm._v(_vm._s(data.item.LEI))])
                            : data.item.EUID !== ""
                            ? _c("span", [_vm._v(_vm._s(data.item.EUID))])
                            : _c("span", [_vm._v(" - ")]),
                        ]
                      },
                    },
                    {
                      key: "cell(Result)",
                      fn: function (data) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getResultDDD(data.item))),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(TechStatusCode)",
                      fn: function (data) {
                        return [
                          data.item.TechStatusCode !== ""
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.translateTechStatusCode(
                                      data.item.TechStatusCode
                                    )
                                  )
                                ),
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("common.monitoring.success")) +
                                    " "
                                ),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "cell(Provider)",
                      fn: function (data) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(data.value == 1 ? "STET" : "EBA")),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(ResponseDuration)",
                      fn: function (data) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getDuration(data.item))),
                          ]),
                        ]
                      },
                    },
                    _vm.flagCACP
                      ? {
                          key: "cell(ResultEntity)",
                          fn: function (data) {
                            return [
                              data.item.IdScore2 !== ""
                                ? _c("span", [
                                    _c("span", {
                                      staticClass: "result-vignette",
                                      class: {
                                        "result-mtch":
                                          data.item.IdScore2 === "MTCH",
                                        "result-nmtc":
                                          data.item.IdScore2 === "NMTC",
                                        "result-cmtc":
                                          data.item.IdScore2 === "CMTC",
                                        "result-noap":
                                          data.item.IdScore2 === "NOAP",
                                      },
                                    }),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.getResultText(data.item.IdScore2)
                                        ) +
                                        "\n          "
                                    ),
                                  ])
                                : data.item.NameScore2 !== ""
                                ? _c("span", [
                                    _c("span", {
                                      staticClass: "result-vignette",
                                      class: {
                                        "result-mtch":
                                          data.item.NameScore2 === "MTCH",
                                        "result-nmtc":
                                          data.item.NameScore2 === "NMTC",
                                        "result-cmtc":
                                          data.item.NameScore2 === "CMTC",
                                        "result-noap":
                                          data.item.NameScore2 === "NOAP",
                                      },
                                    }),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.getResultText(
                                            data.item.NameScore2
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ])
                                : _c("span", [_vm._v(" - ")]),
                            ]
                          },
                        }
                      : null,
                    _vm.flagCACP
                      ? {
                          key: "cell(ReasonCodeAll)",
                          fn: function (data) {
                            return [
                              data.item.ReasonCodeEntity
                                ? _c("span", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "tracking.flagCACP.reason_code_optional_entity_list." +
                                              data.item.ReasonCodeEntity
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ])
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        }
                      : null,
                    {
                      key: "cell()",
                      fn: function (data) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(data.value ? data.value : "-")),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        : _c("div", { staticClass: "d-flex justify-content-center" }, [
            _vm.flagCACP && (_vm.tabName === 1 || _vm.tabName === 2)
              ? _c("span", { staticClass: "noResult" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.isMandatoryFieldMiss
                          ? _vm.$t("common.missing_required_field")
                          : _vm.$t("common.no_result")
                      ) +
                      "\n      "
                  ),
                ])
              : _c("span", { staticClass: "noResult" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.no_result")) +
                      "\n      "
                  ),
                ]),
          ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              !_vm.flagCACP
                ? _c("cm-pagination", {
                    attrs: {
                      maxResultsByPage: _vm.paginationObject.maxResults,
                      firstIndex: _vm.paginationObject.firstIndex,
                      nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                      refreshEvent: _vm.paginationObject.refresh,
                    },
                  })
                : _c("cm-pagination-tracking-cacp", {
                    attrs: {
                      maxResultsByPage: _vm.paginationObject.maxResults,
                      firstIndex: _vm.paginationObject.firstIndex,
                      nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                      refreshEvent: _vm.paginationObject.refresh,
                      "has-next": _vm.paginationObject.hasNext,
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }